module.exports = __webpack_public_path__ + "img/new-object-joyful.65766c0d.png";